import { defineStore } from 'pinia';
import api from '@/app/api/axios.js';
import { reactive, ref } from 'vue';

export const useSSLStore = defineStore('ssl', () => {
    const state = reactive({
        page: 1,
        sort: 'status',
        status: [],
        type: [],
    });
    const search = ref('');
    const columnVisibility = ref(['name', 'product', 'status', 'validation_method', 'linked', 'edit']);

    const setPage = (newPage) => {
        state.page = newPage;
    };

    const setSort = (newSort) => {
        state.sort = newSort;
    };

    const setFilters = (newFilters) => {
        Object.keys(newFilters).forEach((key) => {
            if (newFilters[key] === undefined) {
                return;
            }

            state[key] = newFilters[key];
        });
        setPage(1);
    };

    const setSearch = (newSearch) => {
        search.value = newSearch;
        setPage(1);
    };

    const setColumnVisibility = (columns) => {
        columnVisibility.value = columns;
    };

    const resetFilters = () => {
        state.page = 1;
        state.status = [];
        state.type = [];
        search.value = '';
    };

    function getSSLCertificateStatus(certificate) {
        return api.get(`/general/ssl-certificates/${certificate}/request-status`);
    }

    function downloadSSLCertificate(certificate) {
        return api.get(`/general/ssl-certificates/${certificate}/download`, {
            responseType: 'blob',
        });
    }

    function renewSSLCertificate(certificate) {
        return api.post(`/general/ssl-certificates/${certificate}/renew`);
    }

    function revokeSSLCertificate(certificate) {
        return api.get(`/general/ssl-certificates/${certificate}/revoke`);
    }

    function resendApprovalEmailSSLCertificate(certificate) {
        return api.get(`/general/ssl-certificates/${certificate}/resend-approval-email`);
    }

    function getApprovalListSSLCertificate(certificate) {
        return api.get(`/general/ssl-certificates/${certificate}/approval-list`);
    }

    function getValidationMethod(commonName) {
        return api.get(`/general/ssl-certificates/${commonName}/validation`);
    }

    const dehydrate = () => {
        resetFilters();
        state.sort = 'status';
        state.type = [];
        columnVisibility.value = ['name', 'product', 'status', 'validation_method', 'linked', 'edit'];
    };

    return {
        state,
        search,
        columnVisibility,
        setPage,
        setSort,
        setFilters,
        setSearch,
        setColumnVisibility,
        resetFilters,
        dehydrate,
        getSSLCertificateStatus,
        downloadSSLCertificate,
        renewSSLCertificate,
        revokeSSLCertificate,
        resendApprovalEmailSSLCertificate,
        getApprovalListSSLCertificate,
        getValidationMethod,
    };
});
